import * as EventListener from "../common/helpers/event-listener";
import flatpickr from "flatpickr";
import csrfToken from "../common/helpers/csrf-token";

const initEventEditCalendar = () => {
    const userEventForm = document.getElementById("userEventForm");

    if (!userEventForm) {
        return;
    }

    const eventAt = document.getElementById("event_at").value.trim();
    const reminder = document.getElementById("reminder").value;

    const today = new Date();
    const minDate = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + Number(reminder),
    );

    const dayOfWeekData = JSON.parse(
        document.getElementById("dayOfWeekData").value,
    );
    const monthData = JSON.parse(document.getElementById("monthData").value);

    let defaultDate = null;

    if (eventAt) {
        defaultDate = new Date(eventAt) > minDate ? eventAt : minDate;
    } else {
        defaultDate = minDate;
    }

    flatpickr("#event_at", {
        inline: true,
        prevArrow: "<",
        nextArrow: ">",
        dateFormat: "Y-m-d",
        defaultDate: defaultDate,
        minDate: minDate,
        maxDate: new Date(
            new Date().getFullYear(),
            new Date().getMonth() + 12,
            0,
        ),
        locale: {
            weekdays: {
                shorthand: dayOfWeekData,
                longhand: dayOfWeekData,
            },
            months: {
                shorthand: monthData,
                longhand: monthData,
            },
        },
    });
};

const changeReminder = () => {
    EventListener.change("reminder", (button) => {
        initEventEditCalendar();
        button.disabled = false;
    });
};

const chooseYearDay = () => {
    EventListener.click("choose-day-button", (button) => {
        const date = button.getAttribute("data-date");

        oc.ajax("Settings::onAjax", {
            loading: "#loader-line",
            data: {
                _token: csrfToken,
                calendar_type: "year",
                calendar_date: date,
            },
            update: {
                "user/events": ".year-events-wrapper",
            },
            complete: () => {
                button.disabled = false;
            },
        });

        button.disabled = false;
    });
};

const eventsTypeClick = () => {
    EventListener.change("event-tab", (element) => {
        const hiddenClass = "hidden";
        const yearBlock = document.querySelector(".events-year");
        const monthBlock = document.querySelector(".events-month");

        if (element.id === "button-event-year") {
            yearBlock.classList.remove(hiddenClass);
            monthBlock.classList.add(hiddenClass);
        } else if (element.id === "button-event-month") {
            yearBlock.classList.add(hiddenClass);
            monthBlock.classList.remove(hiddenClass);
        }
        element.disabled = false;
    });
};

const getEventsMap = () => {
    const listEvents = document.getElementById("data-events-list");
    const events = listEvents.dataset.events.split(",");
    const eventMap = new Map();

    for (const event of events) {
        const d = new Date(event);

        if (eventMap.get(d.getMonth())) {
            eventMap.get(d.getMonth()).push(d.getDate());
        } else {
            eventMap.set(d.getMonth(), [d.getDate()]);
        }
    }

    return eventMap;
};

const initMonthCalendar = () => {
    const monthBlock = document.querySelector(".month-container");

    if (monthBlock) {
        const d = new Date();
        const year = d.getFullYear();
        const month = d.getMonth();

        createCalendar(monthBlock, year, month, getEventsMap());
    }
};

const initYearCalendar = () => {
    const yearBlock = document.querySelector(".year-container");

    if (yearBlock) {
        const d = new Date();
        const year = d.getFullYear();

        for (let i = 0; i < 12; i++) {
            const monthBlock = document.createElement("div");
            yearBlock.appendChild(monthBlock);

            createCalendar(monthBlock, year, i, getEventsMap());
        }
    }
};

const createCalendar = (elem, year, month, eventMap) => {
    const monthData = JSON.parse(document.getElementById("monthData").value);
    const dayOfWeekData = JSON.parse(
        document.getElementById("dayOfWeekData").value,
    );
    const calendarParams = {
        months: monthData,
        weekdays_short: dayOfWeekData,
    };

    const getDay = (date) => {
        let day = date.getDay();
        if (day === 0) {
            day = 7;
        }
        return day - 1;
    };

    const d = new Date(year, month);

    let table = `<div class="month-title">${calendarParams.months[month]}</div>`;
    table += "<table><tr>";

    for (let i = 0; i < 7; i++) {
        table += `<th>${calendarParams.weekdays_short[i]}</th>`;
    }

    table += "</tr><tr>";

    // spaces before
    for (let i = 0; i < getDay(d); i++) {
        table += "<td></td>";
    }

    while (d.getMonth() === month) {
        if (eventMap && eventMap.get(month)) {
            if (eventMap.get(month).includes(d.getDate())) {
                const yearStr = d.getFullYear();
                const monthStr = String(d.getMonth() + 1).padStart(2, "0");
                const dayStr = String(d.getDate()).padStart(2, "0");
                const formattedDate = `${yearStr}-${monthStr}-${dayStr}`;

                table += `
                    <td><a href="" class="choose-day-button" data-date="${formattedDate}">${d.getDate()}</a></td>
                `;
            } else {
                table += `<td>${d.getDate()}</td>`;
            }
        } else {
            table += `<td>${d.getDate()}</td>`;
        }

        // last day of week
        if (getDay(d) % 7 === 6) {
            table += "</tr><tr>";
        }

        d.setDate(d.getDate() + 1);
    }

    // spaces after
    if (getDay(d) !== 0) {
        for (let i = getDay(d); i < 7; i++) {
            table += "<td></td>";
        }
    }

    table += "</tr></table>";

    elem.innerHTML = table;
};

initEventEditCalendar();
changeReminder();
initMonthCalendar();
initYearCalendar();
eventsTypeClick();
chooseYearDay();
